/**
 * DividerPropertiesEditor Component
 * 
 * Property editor for Divider block type.
 */

import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { DividerBlockProps } from '@/types/menuBuilder';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface DividerPropertiesEditorProps {
  props: DividerBlockProps;
  onUpdate: (props: Partial<DividerBlockProps>) => void;
}

export const DividerPropertiesEditor = memo(function DividerPropertiesEditor({
  props,
  onUpdate,
}: DividerPropertiesEditorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      {/* Style */}
      <div className="space-y-2">
        <Label>{t('menuBuilder.dividerStyle', 'Divider Style')}</Label>
        <Select
          value={props.style}
          onValueChange={(value) =>
            onUpdate({ style: value as DividerBlockProps['style'] })
          }
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="line">{t('menuBuilder.line', 'Line')}</SelectItem>
            <SelectItem value="dots">{t('menuBuilder.dots', 'Dots')}</SelectItem>
            <SelectItem value="icon">{t('menuBuilder.icon', 'Icon')}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Color */}
      <div className="space-y-2">
        <Label>{t('menuBuilder.color', 'Color')}</Label>
        <div className="flex gap-2">
          <Input
            type="color"
            value={props.color || '#000000'}
            onChange={(e) => onUpdate({ color: e.target.value })}
            className="w-12 h-10 p-1 cursor-pointer"
          />
          <Input
            value={props.color || ''}
            onChange={(e) => onUpdate({ color: e.target.value })}
            placeholder={t('menuBuilder.defaultColor', 'Default')}
            className="flex-1"
          />
        </div>
      </div>
    </div>
  );
});

export default DividerPropertiesEditor;
